import React from 'react';
import PropTypes from 'prop-types';
import './ContactPopup.css';
import { Button } from '../../Button';
import ContactSvg from '../project.svg';

export const ContactPopup = ({ handleContinueFilling, handleContact }) => (
  <div className="contact-content">
    <div className="contact-content__image-container">
      <img
        alt="contact"
        className="contact-content__image-container__image"
        src={ContactSvg}
      />
    </div>
    <div className="contact-content__body">
      <div className="contact-content__body__title">
        Need some help or prefer
        <br />
        us to complete the rest for you?
      </div>
      <div className="contact-content__body__description">
        Based on your selections it sounds like you either
        <br />
        want us to contact you to complete this or may be best suited for our
        managed
        <br />
        service.
      </div>
    </div>
    <div className="contact-content__action">
      <Button
        id="contact-button"
        onClick={handleContact}
        rounded
        block
        title="talk to a representative"
      />
      <Button
        id="continue-button"
        textClassName="contact-content__action--continue"
        onClick={handleContinueFilling}
        transparent
        block
        withoutTextTransform
        title="Continue filing our brief"
      />
    </div>
  </div>
);

ContactPopup.propTypes = {
  handleContinueFilling: PropTypes.func,
  handleContact: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Popup/ContactPopup/ContactPopup.js